export const getAlignment = (placement) => placement.split('-')[1];
